import { useEffect, useState } from 'react';
import { Button, Row, Col, useTranslation } from '@packages/utils';
import { useGetElcMeetingTATimeQuery } from 'redux/apiSlice/elcs.slice';
import { EIconNames, Icon } from 'components/Base/Icon';
import { downloadCSV } from 'helpers/downloadCsv';
import TATimeItem from './TATimeItem';
import AddTATimeForm from './AddTATimeForm';
import { TTATimeTabProps } from './TATimeTab.types';

const TATimeTab = ({ elcId, isDrawerOpen, meetingId }: TTATimeTabProps) => {
  const { t } = useTranslation({
    keyPrefix:
      'descriptions.admin-portal.elcs.detail.meetings-tab.details.ta-time.add',
  });

  const [hideForm, setHideForm] = useState<boolean>(true);
  const { data } = useGetElcMeetingTATimeQuery(
    {
      meetingId,
    },
    {
      skip: !meetingId,
    },
  );

  useEffect(() => {
    if (!data) {
      return;
    }
    if (data.length > 0) {
      setHideForm(true);
    } else {
      setHideForm(false);
    }
  }, [data]);

  if (!data) {
    return null;
  }

  const onCancelForm = () => {
    if (data.length > 0) {
      setHideForm(true);
    }
  };

  return (
    <>
      {hideForm ? (
        <Row justify="space-between" align="middle" className="mb-4">
          <Col>
            <Button
              color="primary"
              type="link"
              className="pl-0"
              onClick={() => setHideForm(false)}
              icon={<Icon icon={EIconNames.PLUS} className="pointer" />}
            >
              {t('ADD_BTN')}
            </Button>
          </Col>
          <Col>
            {data.length > 0 && (
              <Button
                color="primary"
                type="default"
                onClick={() => {
                  const splitDateTime = (value?: string) => {
                    if (!value) {
                      return { date: '', time: '' };
                    }
                    const match = value.match(/(\d{1,2}:\d{2}\s*[AP]M)$/i);
                    if (match && match.index !== undefined) {
                      const time = match[1];
                      const date = value.slice(0, match.index).trim();
                      return { date, time };
                    }
                    return { date: value, time: '' };
                  };

                  downloadCSV(
                    [
                      'Pillar',
                      'Focus',
                      'Time (min)',
                      'Entered By',
                      'Entered On',
                      'Entered On (Time)',
                    ],
                    data,
                    record => {
                      const { date, time } = splitDateTime(
                        record.createdDate || '',
                      );
                      return [
                        record.pillarName,
                        record.focus,
                        record.duration,
                        record.createdBy || '',
                        date,
                        time,
                      ];
                    },
                    'ta-time.csv',
                  );
                }}
                icon={<Icon icon={EIconNames.DOWNLOAD} alt="download icon" />}
              >
                Export
              </Button>
            )}
          </Col>
        </Row>
      ) : (
        <AddTATimeForm
          isDrawerOpen={isDrawerOpen}
          onCancelForm={onCancelForm}
          elcId={elcId}
          meetingId={meetingId}
        />
      )}
      {data.map(item => (
        <TATimeItem key={item.taTimeId} data={item} elcId={elcId} />
      ))}
    </>
  );
};

export default TATimeTab;
